<template>
  <!-- TODO: Make this bg colour react to the theme -->
  <section
    v-if="crumbs.length"
    :style="{ backgroundColor: 'var(--p-brand-navy-500)' }"
  >
    <ContentContainer>
      <ul
        class="list-none py-2 lg:py-4 flex flex-wrap wrap-normal items-start gap-2 font-medium overflow"
      >
        <template v-for="(crumb, i) in crumbs" :key="i">
          <!-- Crumb link -->
          <li class="">
            <NuxtLink
              :to="crumb.url"
              class="text-mbzuai-sand-500! cursor-pointer wrap-break-word transition-all underline decoration-inherit decoration-2! underline-offset-3"
            >
              {{ crumb.label }}
            </NuxtLink>
          </li>

          <!-- Angle right icon -->
          <li class="whitespace-nowrap transition-all text-base">
            <i
              class="pi pi-angle-right leading-normal! text-mbzuai-sand-500!"
            />
          </li>
        </template>

        <!-- Current page -->
        <li
          class="whitespace-break-spaces wrap-break-word transition-all text-surface-0"
        >
          {{ page?.title }}
        </li>
      </ul>
    </ContentContainer>
  </section>
</template>

<script setup lang="ts">
const { getPage } = useDrupalCe();
const page = getPage();

const crumbs = computed(() => page.value?.breadcrumbs);
</script>
